import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, CircularProgress } from '@material-ui/core/';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import AppState from '../../state';
import img_logo from '../../assets/images/logo_lazarus.png';
import Aviso from '../../components/lib/Aviso';

import './style.css';
import MaskedInput from 'react-text-mask';

const emptyState = {
  usuario: '',
  senha: '',
  // Aviso na propria tela, no lugar do alert() bloqueante do navegador.
  aviso: { aberto: false, texto: '', tipo: 'info' },
};

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class Login extends Component {
  state = {
    ...emptyState,
    capsWarning: false,
  };

  _handleChange = (name) => (event) => {
    var value =
      event.target && event.target.value
        ? event.target.value
        : typeof event === 'string'
          ? event
          : '';
    this.setState({ [name]: value });
  };

  _aviso = (texto, tipo = 'info') => {
    this.setState({ aviso: { aberto: true, texto, tipo } });
  };

  _fechaAviso = () => {
    this.setState((estado) => ({ aviso: { ...estado.aviso, aberto: false } }));
  };

  _handlesPasswordInputKeyUp = (event) => {
    if (event.getModifierState('CapsLock')) {
      this.setState({
        capsWarning: true,
      });
    } else {
      this.setState({
        capsWarning: false,
      });
    }

    if (event.keyCode === 13) {
      this._submitLogin();
    }
  };

  _treatLoginData = (token, userData) => {
    console.log('userData:', JSON.stringify(userData));

    if (token) {
      AppState.isLoggedIn = true;
      AppState.token = token;
      AppState.empresa = userData.empresa;
      AppState.idPerfil = userData.id_perfil;
      AppState.userInfo = userData;
    } else {
      this._userLogout();
    }

    let menu = { views: userData.views };
    // Marca de "precisa cadastrar uma senha nova antes de usar o sistema".
    // Quem decide e' o servidor (coluna trocar_senha do usuario).
    localStorage.setItem('trocarSenha', userData.trocar_senha ? '1' : '0');
    localStorage.setItem('token', token);
    localStorage.setItem('Menu', JSON.stringify(menu));
    //localStorage.setItem('userInfo', JSON.stringify({cpf_usuario: userData.cpf_usuario, nome_usuario: userData.nome_usuario}))
    localStorage.setItem(
      'userInfo',
      JSON.stringify({
        cpf_usuario: userData.cpf_usuario,
        nome_usuario: userData.nome_usuario,
        id_perfil: userData.id_perfil
      })
    );
    /*
            AppState.idPerfil = idPerfil;
            if(idPerfil === 1) {
              AppState.isMaster = true;
              AppState.isAdmin = true;
            }
            if(idPerfil === 2) {
              AppState.isAdmin = true;
            }

            localStorage.setItem('idPerfil', idPerfil);
            */
  };

  _submitLogin = () => {
    // Aqui vai a chamada AJAX do Login
    var self = this;
    var usuario = this.state.usuario;
    var senha = this.state.senha;

    const checkStatus = (response) => {
      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        if (response.status == 401) {
          return response.json().then(function (json) {
            var ret = json['status'].value.split(' ')[0];
            if (ret == '40101') self._aviso('Login ou senha incorreto', 'erro');
            else if (ret == '40102') self._aviso('Usuário bloqueado', 'erro');
            else self._aviso('Erro de conexão', 'erro');
          });
        }
        var error = new Error(response.statusText);
        error.response = response;
        this._handleChange('senha')('');
        throw error;
      }
    };

    function parseJSON(response) {
      return response.json();
    }

    function validaForm() {
      //aqui vai a validação
      if (usuario.length !== 14) {
        self._aviso('CPF Inexistente. Insira um CPF Válido.', 'erro');
        return false;
      }

      if (senha.length < 6) {
        self._aviso('A senha deve ter pelo menos 6 dígitos.', 'erro');
        return false;
      }
      return true;
    }


    if (validaForm()) {
      AppState.isLoading = true;
      fetch(
        `${AppState.serverAddr}/comum/Login.php`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify({
            user: usuario,
            pwd: senha,
          }),
        }
      )
        .then(checkStatus)
        .then(parseJSON)
        .then(function (response) {
          const token = response.auth.replace(/['"]+/g, '');
          const userData = response.request;
      
          self._treatLoginData(token, userData);
          AppState.isLoading = false;
      
          return fetch(`${AppState.serverAddr}/config/GetValueInvoiceCurrent.php`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
            },
          });
        })
        .then(checkStatus)
        .then(parseJSON)
        .then(function (invoiceResponse) {
          const isInvoiceCurrent = invoiceResponse.data || 'false';
          localStorage.setItem('noInvoiceCurrent', isInvoiceCurrent);

          // Primeiro acesso (ou senha redefinida por um administrador):
          // a pessoa cadastra a senha dela antes de entrar no sistema. A
          // explicacao aparece como faixa fixa na propria tela de perfil — um
          // aviso passageiro aqui sumiria junto com a troca de tela.
          if (localStorage.getItem('trocarSenha') === '1') {
            browserHistory.push(`${process.env.PUBLIC_URL}/perfil`);
            return;
          }

          if (AppState.userInfo.id_perfil === 'ges_director') {
            browserHistory.push(
              `${process.env.PUBLIC_URL}/relatorio/dashboard-gerencial`
            );
          } else {
            browserHistory.push(`${process.env.PUBLIC_URL}/timesheets`);
          }
        })
        .catch(function (ex) {
          AppState.isLoading = false;
          console.error('Erro ao processar login ou buscar is_invoice_current:', ex);
        });
      
    }
  };

  _submitForgotPassword = () => {
    // Aqui vai a chamada AJAX do Esqueci minha Senha
    var self = this;
    var usuario = this.state.usuario;

    function checkStatus(response) {
      if (!response.ok) {
        return response.json().then((json) => {
          var error = new Error(response.status);
          error.response = json;
          throw error;
        });
      } else {
        return response;
      }
    }

    function parseJSON(response) {
      return response.json();
    }

    if (usuario.length !== 14) {
      this._aviso('Informe o seu CPF no campo do usuário.', 'erro');
      return;
    }
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/comum/RecoverPwD.php`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
          cpf: usuario,
        }),
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(function (response) {
        AppState.isLoading = false;
        // A resposta e' a mesma exista o CPF ou nao, e mesmo que o envio falhe
        // — de proposito, pra ninguem conseguir descobrir pelo comportamento da
        // tela quais CPFs tem cadastro no sistema financeiro.
        self._aviso(
          'Se este CPF tiver cadastro, enviamos um link para o e-mail dele.\n' +
          'O link vale por 1 hora e serve uma vez só. Confira também a caixa de spam.',
          'sucesso'
        );
      })
      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          self._aviso('Erro desconhecido, tente novamente', 'erro');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          self._aviso('Informe o seu CPF no campo do usuário.', 'erro');
        } else if (Err_status == 500) {
          self._aviso(
            'O sistema não respondeu agora. Tente de novo em alguns minutos.\n' +
            'Se continuar, avise o setor de TI.',
            'erro'
          );
        } else {
          self._aviso('Erro, operação não realizada.', 'erro');
        }
      });
  };

  render() {
    return (
      <div id="Login" className="login-place">
        <Aviso
          aberto={this.state.aviso.aberto}
          texto={this.state.aviso.texto}
          tipo={this.state.aviso.tipo}
          aoFechar={this._fechaAviso}
        />
        <div className="logo-header">
          <img className="logo-img" src={img_logo} alt="Lazarus" />
        </div>
        <div className="right-content">
          <div>
            <div className="box-login">
              {AppState.isDevMode && <p>Ambiente de testes</p>}

              <TextField
                id="usuario"
                label="USUÁRIO"
                placeholder="CPF"
                InputProps={{
                  inputComponent: TextMaskCustom,
                  value: this.state.usuario,
                  onChange: this._handleChange('usuario'),
                }}
              />

              <TextField
                id="senha"
                label="SENHA"
                fullWidth={true}
                type="password"
                inputProps={{
                  maxLength: 72,
                }}
                value={this.state.senha}
                onChange={this._handleChange('senha')}
                onKeyUp={this._handlesPasswordInputKeyUp}
              />

              {this.state.capsWarning && (
                <p style={{ color: 'red', marginTop: '8px' }}>
                  O CapsLock está ativado!
                </p>
              )}

              <div className={'buttons'}>
                <Button
                  className={'btn-login'}
                  color="primary"
                  variant="contained"
                  onClick={this._submitLogin}
                >
                  entrar
                </Button>
                <Button
                  className="btn-forget-place"
                  variant="outlined"
                  onClick={this._submitForgotPassword}
                >
                  Esqueci minha senha
                </Button>
              </div>
            </div>
          </div>
        </div>
        {AppState.isLoading && (
          <div className="loading-overlay">
            <div className="loading-container">
              <CircularProgress size={60} thickness={4} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default observer(Login);
